import { render, staticRenderFns } from "./MandatsOwnEntity.vue?vue&type=template&id=26cc17d8&"
import script from "./MandatsOwnEntity.vue?vue&type=script&lang=js&"
export * from "./MandatsOwnEntity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports